import { render, staticRenderFns } from "./ListQuotes.vue?vue&type=template&id=0cf0a6c3"
import script from "./ListQuotes.vue?vue&type=script&lang=js"
export * from "./ListQuotes.vue?vue&type=script&lang=js"
import style0 from "./ListQuotes.vue?vue&type=style&index=0&id=0cf0a6c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports